module.exports = __webpack_public_path__ + "static/media/Flyer2022.8c0e52d7.jpeg";